import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CompanyRate } from 'src/app/modules/companies/_types/company-rate';
import { CompanyRatesService } from 'src/app/modules/companies/_services/companies-rates.service';
import { CompaniesService } from 'src/app/modules/companies/_services/companies.service';
import { ContractsService } from 'src/app/modules/companies/_services/contracts.service';

@Component({
    selector: 'app-company-contracts',
    templateUrl: './company-contracts.component.html',
    styleUrls: ['./company-contracts.component.scss'],
    standalone: false
})
export class CompanyContractsComponent {

 // public CompanyContractFormGroup!: RxFormGroup;

  public companies: any[] = [];
  public contracts: any[] = [];
  public selectedContracts: any[] = [];
  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public results: any = {companyId: null, selectedContracts: []};

  constructor(
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private companiesService: CompaniesService,
    private contractsService: ContractsService
  ) {
    //this.CompanyContractFormGroup = this.formBuilder.formGroup<CompanyRate>(this.templateContract) as RxFormGroup;
  }

  ngOnInit(): void {
    
    if (this.config.data.companyId) {
      this.results.companyId = this.config.data.companyId;
    }
    if (this.config.data.selectedContracts) {
      if (this.config.data.companyId) this.results.selectedContracts = this.config.data.selectedContracts;
      this.selectedContracts = this.config.data.selectedContracts;
    }
    this.loadCompanies();
    //this.loadContracts();

    this.allowWrite = true;
    this.allowDelete = true;
  }

  async loadCompanies() {
    let response = await firstValueFrom(this.companiesService.all());
    this.companies = response.data;
  }

  async loadContracts() {
    let filters = {
      companyId: new Filter(FilterOperation.equals, 'companyId', "", this.results.companyId)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build()
    };

    let response = await firstValueFrom(this.contractsService.all(params));
    this.contracts = response.data;

    if(this.selectedContracts.length > 0 && this.contracts.length>0){
      this.results.selectedContracts = this.contracts.filter((m:any) => this.selectedContracts.findIndex((model:any) => model == m.id) != -1).map(m => m.id);
    }
  }

  async save() { 
    
    let success = true;
    if(this.results.companyId == null) success = false;
    if (success) {
      this.messageService.add({ closable: true, severity: 'success', detail: "Compañía aseguradora asignada correctamente." });
      this.dynamicDialogRef.close(this.results);
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Error al asignar la compañía aseguradora." });
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

}
